import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-check" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["value", "name", "id", "required", "aria-label", "aria-describedby", "aria-invalid"]
const _hoisted_4 = { class: "label-text" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { key: 0 }

import { toRef } from 'vue';
import { useField } from 'vee-validate';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomCheckbox',
  props: {
  value: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  arialabel: {
    type: String,
    required: false,
  },
  required: { 
    type: Boolean,
    default: false
  },
},
  setup(__props) {

const props = __props;

// we are using toRefs to create reactive references to `name` and `value` props
// this is important because vee-validte needs to know if any of these props change
// https://vee-validate.logaretm.com/v4/guide/composition-api/caveats

const name = toRef(props, "name");

const { checked, handleChange, errorMessage } = useField(name, undefined, {
  type: 'checkbox',
  checkedValue: props.value,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "checkbox blue",
      for: __props.id
    }, [
      _createElementVNode("input", {
        type: "checkbox",
        value: __props.value,
        class: _normalizeClass(["form-check_input", { 'error': !!_unref(errorMessage)}]),
        name: name.value,
        id: __props.id,
        required: __props.required,
        "aria-label": __props.arialabel,
        "aria-describedby": 'texterror' + __props.id,
        "aria-invalid": !!_unref(errorMessage),
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleChange) && _unref(handleChange)(...args)))
      }, null, 42, _hoisted_3),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "indicator" }, null, -1)),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.label), 1)
    ], 8, _hoisted_2),
    _createElementVNode("span", {
      id: 'texterror' + __props.id,
      class: "error-txt"
    }, [
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_5)
  ]))
}
}

})